import { render, staticRenderFns } from "./ShopDialog.vue?vue&type=template&id=2cd18a52"
import script from "./ShopDialog.vue?vue&type=script&lang=js"
export * from "./ShopDialog.vue?vue&type=script&lang=js"
import style0 from "./ShopDialog.vue?vue&type=style&index=0&id=2cd18a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports